import React, { useState } from 'react'
import { 
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { withRouter } from 'react-router'

const messages = {
  error: 'Oops! Something went wrong. Please choose a suitable option to proceed',
  return: 'Return',
  details: 'Load details',
}

const useStyles = makeStyles(theme => ({ 
  buttonGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
  margin: theme.spacing(1),
  justifyContent: 'flex-end'
  },
}))

const ErrorPage = (props) => {
  const classes = useStyles()
  const {componentStack, error} = props
  const [displayError, updateDisplay] = useState(false)
  let history = useHistory()

  return (
    <div>
      <Dialog
        open={true}
        fullWidth
      >
        <DialogTitle >{"Something Failed"}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText >
            {messages.error}
          </DialogContentText>
          <div className={classes.buttonGrid}>
            <Button variant="contained" className={classes.button}  onClick= {() => { history.push("/"); window.location.reload(); }}>{messages.return}</Button>
            <Button variant="contained" className={classes.button} onClick= {() => updateDisplay(true)}>{messages.details}</Button>
          </div>
          {(displayError) ?
            <div style= {{maxHeight: 140, overflowY: 'auto'}}>
              <details style={{ whiteSpace: "pre-wrap" }}>
                {error && error.toString()}
                <hr />
                {componentStack}
              </details>
            </div> : null}
        </DialogContent>
      </Dialog>
    </div>
  )
};

export default withRouter(ErrorPage)


